import { render, staticRenderFns } from "./miniProPay.vue?vue&type=template&id=5ff1f877&scoped=true"
import script from "./miniProPay.vue?vue&type=script&lang=js"
export * from "./miniProPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1f877",
  null
  
)

export default component.exports